import { ErrorStringFromException } from "../../../utils/utils";
import { IAuthenticationProvider, AuthEnvironment, UIAuthProvider, CheckAndThrowCannotGetAuthContextError, GetAccessTokenOptions } from "../../interfaces/IAuthenticationProvider";
import { AuthError, AuthErrors } from "./AuthErrors";
import { AuthSharedComponent } from "./AuthSharedComponent";

/*
    PPE stands for "Pre-production environment". Typically, resources in this
    environment would have the string "ppe" appended somewhere on their URL.

    For ex: www.officeppe.com, www.spoppe.com, etc
*/
export class PpeAuthenticationProvider implements IAuthenticationProvider {
    private authSharedComponent: AuthSharedComponent = new AuthSharedComponent();

    Authenticate(): void {
        OfficeFirstPartyAuth.debugging = true;
        OfficeFirstPartyAuth.authorityOverride = "https://login.windows-ppe.net/";
        this.authSharedComponent.Authenticate();
    }

    async GetAccessToken(options: GetAccessTokenOptions): Promise<string> {
        try {
          return await this.authSharedComponent.GetAccessToken(options);
      } catch (error : any) {
        CheckAndThrowCannotGetAuthContextError(error);
        throw new AuthError(AuthErrors.UnableToFetchToken, ErrorStringFromException(error));
      }
    }

    GetAuthEnvironment(): AuthEnvironment {
        return AuthEnvironment.PPE;
    }

    SetUIAuthProvider(_uiAuthProvider: UIAuthProvider): void {
        throw new Error("Method not implemented.");
    }
}